<template>
  <div class="page-content-inner pt-lg-0  pr-lg-0 mt-4">
    <h3>{{ $t('education.catalog_education') }}</h3>
    <div v-if="errorMessages?.length" class="uk-alert-danger" uk-alert>
      <template v-for="(error, index) in errorMessages">
        <span v-if="error != null" :key="index">
          <a class="uk-alert-close" uk-close></a>
          <p class="m-0" style="color: red">
            <i class="uil-exclamation-triangle"></i> {{ error }}
          </p>
        </span>
      </template>
    </div>
    <div v-if="successMessage" class="uk-alert-success" uk-alert>
      <a class="uk-alert-close" uk-close></a>
      <p style="color: green">
        <i class="uil-exclamation-triangle"></i> {{ successMessage }}
      </p>
    </div>
    <div v-if="!defaultLoadingModal" class="section-header pb-0 mb-4">
      <div class="section-header-left">
        <!-- <form @submit.prevent="applyFilter"> -->
        <input v-model="searchQuery" :placeholder="$t('home.Education_shearing')" class="mt-3" type="text"
               @input="isTyping = true">
        <!-- </form> -->
      </div>
      <div class="section-header-right">
        <select v-model="order_by" class="ml-3 mb-0" @change="applyFilter">
          <option value="name">{{ $t('filter.Filter_by_name') }}</option>
          <option value="training_type_id">{{ $t('filter.Filter_by_category') }}</option>
          <option value="created_at">{{ $t('filter.Filter_by_date') }}</option>
        </select>
      </div>
    </div>
    <div v-if="!defaultLoadingModal" class="ro" uk-grid>
      <div class="uk-width-1-3@m">
        <nav class="responsive-tab style-3 setting-menu card"
             uk-sticky="top:30 ; offset:100; media:@m ;bottom:true; animation: uk-animation-slide-bottom">
          <ul class="side-list" uk-accordion>
            <li class="">
              <a class="uk-accordion-title" href="#"><i class="uil-book-alt"></i> {{ $t('home.Categories') }}</a>
              <div class="uk-accordion-content">
                <ul class="ks-cboxtags">
                  <li v-for="(item, index) in educationTypes" :key="index">
                    <input id="checkboxOne" v-model="options" :value="item.id" type="checkbox" @change="applyFilter">
                    <label for="checkboxOne">
                      {{ item.name }}
                    </label>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <a class="uk-accordion-title" href="#"><i class="uil-notes"></i> {{
                  this.$t('general.training_types')
                }}</a>
              <div class="uk-accordion-content">
                <ul class="ks-cboxtags">
                  <li>
                    <input id="checkboxTypeOne" v-model="kinds" :value="0" checked type="checkbox"
                           @click="applyFilter($event)">
                    <label for="checkboxTypeOne">{{ $t('general.all') }}</label>
                  </li>
                  <li v-for="(item, index) in formattedTrainingKind" :key="index">
                    <input id="checkboxTwo" v-model="kinds" :value="item.id" type="checkbox"
                           @click="applyFilter(item.id)">
                    <label for="checkboxTwo">
                      {{ item.name }}
                    </label>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </nav>
      </div>
      <!--super admin için-->
      <div v-if="superAdmin()" class="uk-width-2-3@m">
        <div class="card rounded">
          <div class="p-3 d-flex align-items-center justify-content-between">
            <h5 class="mb-0"> {{ selected_type.name }}
              <span style="font-weight:300;">({{
                  itemsDisplay ? itemsDisplay.total : 0
                }} {{ $t('education.education') }} {{ $t('general.being_displayed') }})</span>
            </h5>
            <div>
              <button class="btn btn-sm btn-soft-secondary mr-2" type="button" @click="allUserToggle()">
                <i class="uil-check-square"></i> {{ selectAllTrainingText }}
              </button>
              <button :class="{
                'disabled': training_ids?.length === 0
              }" class="btn btn-success ml-1 " @click="openLicenceModal()"><i class="uil-location-arrow"></i>
                {{ $t('general.license_selected') }}
              </button>
              <div id="modal_catalog_add" class=" uk-modal" uk-modal="">

                <div class="uk-modal-dialog" style="width:100%">

                  <button class="uk-modal-close-default" type="button" uk-close></button>
                  <div class="uk-modal-header">
                    <h2 class="uk-modal-title">{{ $t('general.licensing_educations_selected', { count: training_ids?.length }) }}</h2>
                  </div>
                  <div class="card">
                    <div v-if="errorMessages?.length" class="uk-alert-danger" uk-alert>

                      <template v-for="(error, index) in errorMessages">
                        <span v-if="error != null" :key="index">
                          <a class="uk-alert-close" uk-close></a>
                          <p class="m-0" style="color: red">
                            <i class="uil-exclamation-triangle"></i> {{ error }}
                          </p>
                        </span>
                      </template>
                    </div>
                    <div v-if="successMessage" class="uk-alert-success" uk-alert>
                      <a class="uk-alert-close" uk-close></a>
                      <p style="color: green">
                        <i class="uil-exclamation-triangle"></i> {{ successMessage }}
                      </p>
                    </div>
                    <!-- Card header -->
                    <div class="card-header actions-toolbar border-0">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="row" style="width:100%">
                          <div class=" col-md-1  search-icon ">
                            <i class="uil-search"></i>
                          </div>
                          <div class="col-md-11 uk-search uk-search-navbar" style="margin-left:-2rem">
                            <input v-model="filter.search" :placeholder="$t('general.search')" autofocus=""
                                   class="uk-search-input shadow-0 uk-form-small" type="search" @change="filterResult"/>
                          </div>
                        </div>
                        <div class="d-flex">
                          <!-- Shorting -->
                          <a :uk-tooltip="$t('filters.order.sort')" aria-expanded="false"
                             class="btn btn-icon btn-hover  btn-circle" href="javascript:void(0)" title="">
                            <i class="uil-list-ui-alt"></i>
                          </a>
                          <div class="uk-dropdown"
                               uk-dropdown="pos: bottom-right ; mode: click ;animation: uk-animation-scale-up">
                            <ul class="uk-nav uk-dropdown-nav">
                              <li class="uk-active"><a href="javascript:void(0)" @click="sortOrder('name', 'asc')">{{
                                  $t('filters.order.a_z')
                                }}</a></li>
                              <li><a href="javascript:void(0)" @click="sortOrder('name', 'desc')">{{
                                  $t('filters.order.z_a')
                                }}</a>
                              </li>
                              <li><a href="javascript:void(0)" @click="sortOrder('created_at', 'asc')"> {{
                                  $t('filters.order.created_at_asc')
                                }}</a></li>
                              <li><a href="javascript:void(0)" @click="sortOrder('created_at', 'desc')"> {{
                                  $t('filters.order.created_at_desc')
                                }}</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Table -->
                  <div class="table-responsive">
                    <table class="table align-items-center">
                      <thead>
                      <tr>
                        <th scope="col"></th>
                        <th scope="col">{{ $t('institution.list.company_name') }}</th>
                        <th scope="col">{{ $t('institution.list.contract_expired_date') }}</th>
                        <th scope="col">{{ $t('institution.list.created_at') }}</th>
                        <th scope="col">{{ $t('general.number_of_users') }}</th>
                        <th scope="col"></th>
                      </tr>
                      </thead>
                      <tbody class="list">
                      <!--user item-->
                      <tr v-for="institution in formattedItem">
                        <th>
                          <div style="display:flex;justify-content:center">
                            <input v-if="training_ids?.length > 1" :id="'notification_checkbox_' + institution.id"
                                   v-model="company_ids" :value="institution.id"
                                   style="margin: 0px 0px 0px 10px" type="radio">
                            <input v-if="training_ids?.length < 2" :id="'notification_checkbox_' + institution.id"
                                   v-model="company_ids" :value="institution.id" style="margin: 0px 0px 0px 0px"
                                   type="checkbox"/>
                          </div>
                        </th>
                        <th scope="row">
                          <div class="media align-items-center">
                            <div>
                              <div class="avatar-parent-child" style="width: max-content">
                                <img :src="institution.logo_link" alt="Image placeholder"
                                     class="avatar  rounded-circle">
                              </div>
                            </div>
                            <div class="media-body ml-4">
                              <a class="name h6 mb-0 text-sm">{{ institution.name }}</a>
                              <small class="d-block font-weight-bold">#{{ institution.id }}</small>
                            </div>
                          </div>
                        </th>
                        <td>{{ institution.end_date }}</td>
                        <td> {{ institution.created_at }}</td>
                        <td> {{ institution.users_count }}</td>

                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <pagination :page.sync="pageProxy" :pagination="pagination" @changePage="setPage($event)">
                  </pagination>
                  <div class="uk-modal-footer uk-text-right">
                    <button class="uk-button uk-button-default uk-modal-close" type="button">{{ $t('general.give_up') }}</button>
                    <button class="uk-button uk-button-primary ml-2" type="button" @click="saveCheckedInstitution()"> {{
                        $t("general.save")
                      }}
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <template v-for="(subItem, index) in itemsDisplay.data"
                    v-if="itemsDisplay && itemsDisplay.data && itemsDisplay.data?.length">
            <hr class="m-0">
            <div class="uk-grid-small p-4 position-relative" uk-grid>
              <div v-if="subItem.self_registrable_trainings?.length > 0
                && subItem.company_id === 1" class="ribbon ribbon-top-left" style="height:50%">
                <span>{{ $t('general.rented') }}</span>
              </div>
              <div v-if="subItem.self_registrable_trainings?.length > 0 && subItem.company_id !== 1"
                   class="ribbon ribbon-top-left" style="height:50%">
                <span>{{ $t('general.education') }}</span>
              </div>
              <div class="row" style="margin-top:4px ;width: 100%;">
                <div class="col-md-2">
                  <input :id="'notification_checkbox_' + subItem.id" v-model="training_ids" :value="subItem.id"
                         style="width: 15px; margin-top: 38px" type="checkbox"/>
                </div>
                <div class="col-md-4">
                  <img :src="subItem.cover_image_link" alt="" class="rounded card-cover-image">
                </div>
                <div class="col-md-6">
                  <a>
                    <h5 class="mb-2">
                      {{ subItem.name }} <span v-if="subItem.catalog_anz_education_id" style="color:#36b37e">{{ $t('general.pulled_from_catalog') }} </span><span v-if="subItem.company_id !== 1" style="color:#36b37e">{{ $t('general.institution_education') }}</span>
                      <span class="float-right d-flex" style="margin-top:9px">
                        <a v-if="!subItem.show_to_user" class="btn btn-outline-danger btn-sm ml-2"
                           href="javascript:void(0)" :uk-tooltip="$t('general.companies_not_seeing')"
                           @click="changeStatus(subItem.id)"><i class="uil-eye-slash"></i></a>
                        <a v-else class="btn btn-outline-success btn-sm ml-2" href="javascript:void(0)"
                           :uk-tooltip="$t('general.companies_seeing')" @click="changeStatus(subItem.id)"><i class="uil-eye"></i></a>
                        <a class="btn btn-icon btn-hover btn-sm btn-circle ml-2" href="javascript:void(0)"
                           :uk-tooltip="`title: ${$t('general.edit')}; pos: bottom`" @click="handleOnClickCard('goEditPage', subItem.id)"><i>
                            class="uil-edit"></i></a>
                        <a  class="btn btn-icon btn-hover btn-sm btn-circle ml-2" href="javascript:void(0)"
                           :uk-tooltip="`title: ${$t('general.delete')}; pos: bottom`"
                           @click="handleOnDeleteCard(subItem.id, subItem.has_been_assigned)"><i
                            class="uil-trash text-danger"></i></a>
                      </span>
                    </h5>
                    <p class="mb-0 uk-text-small mt-3">
                      <span class="mr-3 bg-light p-2 mt-1"> {{
                          $t('education.section_count', { 'number': subItem.training_content_count }) + ' / ' +
                          $t('education.content_count', { 'number': subItem.training_content_count })
                        }}</span>
                    </p>
                    <p class="uk-text-small mb-1 mt-2">{{ subItem.description }}</p>
                    <p class="uk-text-small mb-1 mt-1">{{ subItem.training_type?.name }}</p>
                  </a>
                </div>
              </div>
            </div>
          </template>
        </div>
        <PaginationTable v-if="itemsDisplay && itemsDisplay.data && itemsDisplay.last_page !== 1" :page.sync="pageProxy"
                         :paginate="itemsDisplay">
        </PaginationTable>
      </div>
      <!--kurum admin için-->
      <div v-if="!superAdmin()" class="uk-width-2-3@m">

        <div class="card rounded">
          <div class="p-3 d-flex align-items-center justify-content-between">
            <h5 class="mb-0"> {{ selected_type.name }}
              <span style="font-weight:300;">({{
                  itemsDisplay ? itemsDisplay.total : 0
                }} {{ $t('education.education') }} {{ $t('general.being_displayed') }})</span>
            </h5>
            <!-- <div>
              <button type="button" class="btn btn-sm btn-soft-secondary mr-2" @click="allUserToggle()">
                <i class="uil-check-square"></i> {{ selectAllTrainingText }}
              </button>
            </div> -->
          </div>
          <template v-for="(subItem, index) in itemsDisplay.data">
            <hr class="m-0">
            <div class="uk-grid-small p-4 position-relative" uk-grid>
              <div v-if="subItem.self_registrable_trainings?.length > 0" class="ribbon ribbon-top-left"
                   style="z-index:1;">
                <span>{{ $t('general.rented') }}</span>
              </div>
              <div v-if="subItem.company_id === userInfo?.company_id" class="ribbon ribbon-top-left" style="z-index:1;">
                <span>{{ $t('general.education') }}</span>
              </div>
              <div class="row w-100">
                <!-- <div class="col-md-1">
                  <input v-model="self_registrable_training_ids" :id="'notification_checkbox_' + subItem.id"
                    :value="subItem.id" style="width: 15px; margin-top: 38px" type="checkbox" />
                </div> -->
                <div class="col-md-3 p-0">
                  <img :src="subItem.cover_image_link" alt="" class="rounded card-cover-image">
                </div>
                <div class="col-md-5 d-flex flex-column">
                  <h5 class="mb-0">{{ subItem.name }}</h5>
                  <p class="mb-0 uk-text-small">
                    <span class="mr-3 bg-light mt-1"> {{
                        $t('education.section_count', { 'number': subItem.training_content_count }) + ' / ' +
                        $t('education.content_count', { 'number': subItem.training_content_count })
                      }}</span>
                    <span class="d-block">{{ subItem.description }}</span>
                  </p>
                  <p class="uk-text-small mb-1 mt-1">{{ subItem.training_type?.name }}</p>

                </div>
                <div class="col-md-4">
                  <div class="row mb-2 d-flex justify-content-end">
                    <!-- <a href="javascript:void(0)" v-if="subItem.self_registrable_trainings?.length > 0"
                      class="btn btn-primary btn-sm float-right mb-1" style="font-size: 0.6rem !important"
                      @click="settings(subItem)" uk-toggle="target: #modal-overflow"><i class="uil-location-arrow"></i>
                      {{ $t('menu.company_dashboard.create_assignment') }}</a> -->
                    <!-- <button class="btn btn-sm btn-default mb-1" type="button" aria-expanded="false">
                      <i class="uil-location-arrow"> </i>{{ $t('menu.company_dashboard.create_assignment') }}
                    </button> -->

                    <a class="btn btn-sm btn-primary" href="javascript:void(0)" @click="showUser(subItem.id)"><i
                        class="uil-eye"></i> {{ $t('general.show_to_users') }}
                    </a>
                  </div>

                  <div class="row d-flex justify-content-end flex-nowrap" style="gap: 8px; align-items: center;">

                    <button
                        v-if="isDemoActive(subItem)"
                        class="btn btn-icon btn-hover btn-sm btn-circle"
                        style="background-color: #f5f5f5; border: none; padding: 6px;"
                        type="button"
                        :uk-tooltip="`title: ${$t('general.preview')}; pos: top-right`"
                        @click="handleOnClickCard('goDemoPage', subItem.id)">
                      <i class="uil-eye" style="font-size: 16px; color: #333;"/>
                    </button>

                    <button
                        v-if="subItem.company_id === userInfo?.company_id"
                        class="btn btn-icon btn-hover btn-sm btn-circle"
                        style="background-color: #e0f7fa; border: none; padding: 6px;"
                        type="button"
                        :uk-tooltip="`title: ${$t('general.edit')}; pos: top-right`"
                        @click="handleOnClickCard('goEditPage', subItem.id)">
                      <i class="uil-edit" style="font-size: 16px; color: #00796b;"/>
                    </button>

                    <button
                        v-if="subItem.company_id === userInfo?.company_id"
                        class="btn btn-icon btn-hover btn-sm btn-circle"
                        style="background-color: #ffebee; border: none; padding: 6px;"
                        type="button"
                        :uk-tooltip="`title: ${$t('general.delete')}; pos: top-right`"
                        @click="handleOnDeleteCard(subItem.id, subItem.has_been_assigned)">
                      <i class="uil-trash text-danger" style="font-size: 16px; color: #d32f2f;"/>
                    </button>

                  </div>


                </div>
              </div>

            </div>

          </template>
        </div>
        <PaginationTable v-if="itemsDisplay && itemsDisplay.data && itemsDisplay.last_page !== 1" :page.sync="pageProxy"
                         :paginate="itemsDisplay">
        </PaginationTable>

      </div>

      <div id="shareSettings" class="uk-modal" uk-modal>
        <div class="uk-modal-dialog bggray" style="width: 90%; max-width: 1200px; max-height: 90vh; overflow-y: auto;">
          <button class="uk-modal-close-default" type="button" uk-close @click="closeShareSettingsModal()"></button>
          <div class="p-3 position-relative">
            <UserGroupSelection :key="'user-group-' + checked_training"
                                :added_groups="checked_groups"
                                :added_users="checked_users"
                                :case_detail="!superAdmin() ? 'usersRequestedTraining' : 'adminSelfRegistrableTraining'"
                                :checked_training="checked_training"
                                @setCheckedGroups="($event) => { checked_groups = $event.ids; checked_groups_items = $event.items; } "
                                @setCheckedUsers="($event) => { checked_users = $event; checked_users_items = $event.items; } ">
            </UserGroupSelection>
          </div>
          <div class="modal-footer-custom bggray p-2">
            <div>
              <strong><i class="uil-book-open"></i> {{ selectedTrainingName }}</strong>
            </div>
            <div>
              <button :disabled="isUserAssignmentLoading" class="uk-button uk-button-danger mr-2" type="button" @click="removeCheckedUser()">
                <span v-if="isUserAssignmentLoading" uk-spinner="ratio: 0.6"></span>
                <i v-else class="uil-minus-circle"></i> {{ $t('general.remove_from_selected_users') }}
              </button>
              <button :disabled="isUserAssignmentLoading" class="uk-button uk-button-primary" type="button" @click="saveCheckedUser()">
                <span v-if="isUserAssignmentLoading" uk-spinner="ratio: 0.6"></span>
                <i v-else class="uil-plus-circle"></i> {{ $t('general.add_to_selected_users') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <AddToGroupModal :title="'Kullanıcı Ekle'" @getList="getList($event)"></AddToGroupModal> -->
    <default-loading v-if="defaultLoadingModal"></default-loading>
  </div>
</template>

<script>
import EducationCard from "@/view/components/index/EducationCard";
import PaginationTable from "@/view/components/dataTable/Pagination";
import Pagination from "@/assets/components/Pagination";

import moment from "moment";
import store from '@/core/services'
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import axios from "axios";

import {
  CREATE_ITEM,
  DELETE_ITEM_BY_ID,
  GET_ITEM_DETAIL_BY_ID,
  GET_ITEMS,
  LOADING,
  UPDATE_ITEM_BY_ID
} from "@/core/services/store/REST.module";
import AddToGroupModal from "@/view/company/User/Group/AddToGroupModal";
import {
  BASE_URL as TRAINING_KIND_URL,
  GET_ITEMS as GET_TRAINING_KINDS,
  ITEMS as TRAINING_KINDS,
  MODULE_NAME as MODULE_TRAINING_KIND
} from "@/core/services/store/training_kind.module";
import {
  BASE_URL as COMPANY_URL,
  GET_ITEMS as GET_COMPANY,
  ITEMS as ITEMS_COMPANY,
  MODULE_NAME as MODULE_COMPANY,
} from "@/core/services/store/company.module";
import Swal from "sweetalert2";
import UserGroupSelection from "@/view/components/assignment/UserGroupSelection";

const _TRAINING_KIND_MODULE = MODULE_TRAINING_KIND;

export default {
  name: "EducationCatalog",
  components: {
    EducationCard,
    Pagination,
    PaginationTable,
    DefaultLoading,
    UserGroupSelection,
    AddToGroupModal
  },
  beforeCreate() {
    // this.defaultLoadingModal = true;
    // function registerStoreModule(moduleName, storeModule) {
    //   if (!(store && store.state && store.state[moduleName])) {
    //     store.registerModule(moduleName, storeModule)
    //   }
    // }
    // registerStoreModule(_TRAINING_KIND_MODULE, training_kind_module)
  },
  data() {
    return {
      cachedItems: null, // store verilerini ekle
      defaultLoadingModal: true,
      trainingUrl: "api/training/",
      trainingAssignUrl: "api/training/assign-users/",
      company_ids: [],
      selectAllTrainingText: this.$t('general.select_all'),
      search: null,
      searchQuery: "",
      isTyping: false,
      searchResult: [],
      options: [0],
      kinds: [0],
      order_by: 'name',
      sort: 'desc',
      restUrl: 'api/training',
      educationTypes: [],
      selected_type: {
        id: null,
        name: this.$t('education.all_categories')
      },
      filters: {
        page: 1,
        search: '',
        training_type_id: 0,
        training_kind_id: 0,
        admin_page: true,
        can_show_self_registrable_trainings: true,
        order_by: null,
        sort: null
      },
      successMessage: null,
      errorMessages: [],
      selected_type_name: null,
      trainingCategoryUrl: 'api/training-type',
      page: 1,
      checked_groups: [],
      checked_users: [],
      checked_training: null,
      self_registrable_training_ids: [],
      filter: {
        search: null,
        order_by: null,
        sort: null
      },
      pagination: null,
      training_ids: [],
      allTraining: false,
      allSelfRegistrableTraining: false,
      isUserAssignmentLoading: false
    };
  },
  computed: {
    itemsDisplay() {
      // Eğer cachedItems varsa onu kullan, yoksa ve store'da items varsa onu kullan
      if (this.cachedItems && this.cachedItems.data && this.cachedItems.data.length > 0) {
        return this.cachedItems;
      }
      const storeItems = store.getters[_TRAINING_KIND_MODULE + '/' + TRAINING_KINDS];
      return storeItems || { data: [] };
    },
    userInfo: {
      get: function () {
        return JSON.parse(this.secureLocalStorage("user"));
      }
    },
    institutions: {
      get() {
        return store.getters[MODULE_COMPANY + '/' + ITEMS_COMPANY]
      },
      set(value) {
      }
    },
    formattedItem() {
      let results = [];
      if (this.institutions === null || !("data" in this.institutions)) return [];
      for (let i = 0; i < this.institutions.data?.length; i++) {
        let currentItem = this.institutions.data[i];
        this.pagination = this.institutions;
        if (currentItem) {
          results.push({
            id: currentItem.id,
            logo_link: currentItem.logo_link,
            name: currentItem.name,
            status_id: currentItem.status_id,
            users_count: currentItem.users_count,
            created_at: currentItem.created_at ? moment(currentItem.created_at).format('DD/MM/YYYY HH:mm:ss') : '-',
            end_date: (currentItem.contract) ? currentItem.contract.end_date : "-"
          });
        }
      }
      return results;
    },
    catalog_loading() {
      return store.getters[_TRAINING_KIND_MODULE + '/' + LOADING];
    },
    training_kinds: {
      get() {
        return store.getters[_TRAINING_KIND_MODULE + '/' + TRAINING_KINDS]
      },
      set(value) {
      }
    },
    formattedTrainingKind() {
      let results = [];
      if (!this.training_kinds) return [];
      if (this.training_kinds === null || !("data" in this.training_kinds)) return [];
      this.training_kinds.data.forEach(item => {
        results.push({
          id: item.id,
          value: item.id,
          name: item.name
        });
      });
      return results;
    },
    pageProxy: {
      set(value) {
        this.page = value
        this.applyFilter()
      },
      get() {
        return this.page;
      }
    },
    user_header: {
      get() {
        return JSON.parse(this.secureLocalStorage("user"));
      },
      set() {
      },
    },
    selectedTrainingName() {
      if (!this.checked_training || !this.itemsDisplay?.data) return '';
      const training = this.itemsDisplay.data.find(item => item.id === this.checked_training);
      return training ? training.name : '';
    },
  },
  methods: {
    initializeCachedItems() {
      // İlk veri yüklemesi - başlangıç verileri
      this.$store.dispatch(GET_ITEMS, {
        url: this.restUrl,
        acceptPromise: true,
        filters: this.filters,
      }).then((response) => {
        if (response && response.status && response.data) {
          this.cachedItems = response.data;
          this.defaultLoadingModal = false;
        }
      }).catch(error => {
        console.error("Initial data load error:", error);
        this.defaultLoadingModal = false;
      });
    },
    isDemoActive(item) {
      const isDemoActive = item.training_content.some(content => content.is_demo === 1)
      return isDemoActive
    },
    getList(value) {
      let self = this
      let users_count_left = self.selected_purchase.number_of_users - self.selected_purchase.assigned_users_count;
      if (value.length > users_count_left) {
        self.scrollTop()
        self.errorMessage = this.$t('general.max_allowed_users_count', { count: users_count_left })
        return false
      }
      let formData = new FormData();
      value.forEach(item => {
        formData.append("users[]", item.id);
      })
      formData.append("purchase_id", self.selected_purchase.id);
      self.$store
          .dispatch(CREATE_ITEM, {
            url: self.trainingAssignUrl + self.selected_purchase.id,
            contents: formData,
            acceptPromise: true,
          })
          .then((result) => {
            if (!self.error) {
              // let data = result.data;
              // self.selected_purchase.assigned_users_count = data.purchase_assigned_users_count
              // self.item.total_users_allowed = data.total_users_allowed
              // self.item.assigned_users = data.assigned_users
              self.successMessage = this.$t('general.assignment_completed_successfully');
            } else self.errorMessage = self.error;
          });
    },
    settings(purchase_item) {
      this.selected_purchase = purchase_item
      this.getTrainingDetails(purchase_item.id)
    },
    getTrainingDetails(id) {
      this.$store
          .dispatch(GET_ITEM_DETAIL_BY_ID, {
            url: this.trainingUrl + id,
            filters: { with_requests: true },
            acceptPromise: false,
          })
          .then((result) => {
            if (result.status) {
              this.item = result.data;
            }
          });
    },
    resetMessages() {
      this.successMessage = null;
      this.errorMessages = [];
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    },
    saveCheckedInstitution() {
      if (!Array.isArray(this.company_ids)) {
        this.company_ids = [this.company_ids]
      }
      let sendData = {
        'company_ids': this.company_ids,
        // 'training_ids': this.allTraining ? 'all' : this.training_ids,
        'training_ids': this.training_ids,

      }
      this.$store.dispatch(CREATE_ITEM, {
        url: 'api/self-registrable-trainings',
        contents: sendData,
        acceptPromise: true,
      })
          .then((response) => {
            this.scrollToTop();
            this.training_ids = [];
            this.selectAllTrainingText = this.$t('general.select_all');
            if (!this.error) {
              this.successMessage = this.$t("general.successfully_created");
              this.applyFilter()
            } else {
              this.errorMessages.push(this.error)
            }
            if (response) {
              // this.applyFilter()

              setTimeout(() => {
                this.resetMessages();
                UIkit.modal("#modal_catalog_add").hide();
                this.training_ids = [];
                this.company_ids = [];
              }, 1000);
            }
          });
    },
    superAdmin() {
      if (this.user_header === null || !("roles" in this.user_header)) {
        return false;
      }
      if (this.user_header.roles.length > 2) {
        return true;
      } else {
        return false;
      }
    },
    openLicenceModal() {
      // this.$store.dispatch(MODULE_COMPANY + '/' + GET_COMPANY, {
      //   url: COMPANY_URL,
      //   filters: {
      //     type: this.type,
      //     like: this.filter.search,
      //     page: this.page,
      //     per_page: this.per_page,
      //     order_by: this.filter.order_by,
      //     sort: this.filter.sort,
      //   }
      // }).then(response => {
      if (this.training_ids.length > 1) {
        this.company_ids = [];
      } else {
        this.itemsDisplay.data.every(item => {
          if (item.id === this.training_ids[0]) {
            this.company_ids = item.self_registrable_trainings?.reduce((acc, curr) => {
              // if (!acc.includes(curr.pivot.company_id)) {
              acc.push(curr.pivot.company_id)
              return acc;
              // }
              // return acc
            }, [])
            return false
          } else {
            return true
          }
        })
        // this.items.data.self_registrable_trainings
      }
      UIkit.modal("#modal_catalog_add").show();
    },

    filterResult() {
      this.$store.dispatch(MODULE_COMPANY + '/' + GET_COMPANY, {
        url: COMPANY_URL,
        filters: {
          type: this.type,
          like: this.filter.search,
          page: this.page,
          per_page: 6,
          order_by: this.filter.order_by,
          sort: this.filter.sort,
        }
      })
    },
    sortOrder(order_by, sort) {
      this.page = 1;
      this.filter.order_by = order_by;
      this.filter.sort = sort;

      this.filterResult();
    },
    setPage(page) {
      this.page = page;
      this.filterResult()
    },
    allUserToggle() {
      if (this.selectAllTrainingText === this.$t('general.select_all')) {
        if (this.superAdmin()) {
          this.itemsDisplay.data.forEach((training) => {
            let isSelfTraining = false
            this.training_ids?.every((selfTraining) => {
              if (selfTraining === training.id) {
                isSelfTraining = true
                return true
              } else {
                return true
              }
            });
            if (!isSelfTraining)
              this.training_ids.push(training.id)
          });
          // this.items.data.forEach(training => this.training_ids.push(training.id))
          this.allTraining = true;
        } else {
          this.itemsDisplay.data.forEach((training) => {
            let isSelfTraining = false
            this.self_registrable_training_ids?.every((selfTraining) => {
              if (selfTraining === training.id) {
                isSelfTraining = true
                return true
              } else {
                return true
              }
            });
            if (!isSelfTraining)
              this.self_registrable_training_ids.push(training.id)
          });
          // this.items.data.forEach(training => this.self_registrable_training_ids.push(training.id));
          this.allSelfRegistrableTraining = true;
        }
        this.selectAllTrainingText = this.$t('general.deselect_all');
      } else {
        if (this.superAdmin()) {
          this.itemsDisplay.data.forEach((training) => {
            let isSelfTraining = false
            let selfIndex = 0;
            this.training_ids?.every((selfTraining, index) => {
              if (selfTraining === training.id) {
                isSelfTraining = true
                selfIndex = index;
                return true
              } else {
                return true
              }
            });
            if (isSelfTraining)
              this.training_ids.splice(selfIndex, 1);
          });
          this.allTraining = false
        } else {
          this.itemsDisplay.data.forEach((training) => {
            let isSelfTraining = false
            let selfIndex = 0;
            this.self_registrable_training_ids?.every((selfTraining, index) => {
              if (selfTraining === training.id) {
                isSelfTraining = true
                selfIndex = index;
                return true
              } else {
                return true
              }
            });
            if (isSelfTraining)
              this.self_registrable_training_ids.splice(selfIndex, 1);
          });
          this.allSelfRegistrableTraining = false;
        }
        this.selectAllTrainingText = this.$t('general.select_all');
      }
    },
    showUser(event) {
      this.checked_users = [];
      let checkedTraining = this.itemsDisplay.data.filter(data => data.id == event)
      checkedTraining[0].user_self_register_trainings.forEach(user => {
        this.checked_users.push(user.user_self_register_trainingable_id);
      });
      this.checked_training = event;
      UIkit.modal("#shareSettings").show();
    },
    closeShareSettingsModal() {
      UIkit.modal("#shareSettings").hide();
    },
    saveCheckedUser() {
      if (!this.checked_users || this.checked_users.length === 0) {
        Swal.fire({
          icon: "warning",
          title: this.$t('general.warning'),
          text: this.$t('general.please_select_at_least_one_user'),
          confirmButtonColor: "#ae71ff",
          confirmButtonText: this.$t('general.ok'),
        });
        return;
      }
      this.submitUserAssignment({ is_detached: false });
    },
    removeCheckedUser() {
      if (!this.checked_users || this.checked_users.length === 0) {
        Swal.fire({
          icon: "warning",
          title: this.$t('general.warning'),
          text: this.$t('general.please_select_at_least_one_user_to_remove'),
          confirmButtonColor: "#ae71ff",
          confirmButtonText: this.$t('general.ok'),
        });
        return;
      }
      this.submitUserAssignment({ is_detached: true });
    },
    submitUserAssignment({ is_detached }) {
      this.isUserAssignmentLoading = true;
      const sendData = {
        user_ids: this.checked_users,
        is_detached: !!is_detached,
      };
      this.$store.dispatch(UPDATE_ITEM_BY_ID, {
        url: 'api/trainings/' + this.checked_training + '/user-self-register-trainings',
        contents: sendData,
        acceptPromise: false,
      }).then(() => {
        this.$store.dispatch(GET_ITEMS, {
          url: this.restUrl,
          acceptPromise: false,
          showLoading: false,
          filters: this.filters,
        }).then((response) => {
          this.isUserAssignmentLoading = false;
          if (response) {
            this.cachedItems = response.data;
            // Modal içindeki checked_users listesini güncelle
            this.refreshCheckedUsers();
            // Başarı mesajı göster
            Swal.fire({
              icon: "success",
              title: this.$t('general.success'),
              text: is_detached ? this.$t('general.users_removed_successfully') : this.$t('general.users_added_successfully'),
              confirmButtonColor: "#ae71ff",
              confirmButtonText: this.$t('general.ok'),
              timer: 2000,
              timerProgressBar: true,
            }).then(() => {
              UIkit.modal("#shareSettings").hide();
            });
          }
        }).catch(() => {
          this.isUserAssignmentLoading = false;
        });
      }).catch(() => {
        this.isUserAssignmentLoading = false;
      });
    },
    refreshCheckedUsers() {
      if (!this.checked_training) return;
      const checkedTraining = this.itemsDisplay.data.find(data => data.id === this.checked_training);
      // Vue reaktivitesi için önce boşalt, sonra yeni değerleri ata
      this.checked_users = [];
      this.$nextTick(() => {
        if (checkedTraining && checkedTraining.user_self_register_trainings) {
          this.checked_users = checkedTraining.user_self_register_trainings.map(
            user => user.user_self_register_trainingable_id
          );
        }
      });
    },
    changeStatus(id) {
      axios.get(`/api/set-training-visibility/${id}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer " + this.secureLocalStorage("token"),
        }
      }).then(() => {
        this.applyFilter()
      })
    },
    searchUser(searchQuery) {
      this.$set(this.filters, 'page', this.page)
      this.$set(this.filters, 'training_type_id', this.options)
      this.$set(this.filters, 'training_kind_id', this.kinds)
      this.$set(this.filters, 'search', this.searchQuery)
      this.$set(this.filters, 'order_by', this.order_by);
      this.$store.dispatch(GET_ITEMS, {
        url: this.restUrl,
        acceptPromise: false,
        filters: this.filters,
        showLoading: true,
      }).then((response) => {
        if (response) {
          this.cachedItems = response.data;
        }
      })
    },
    deleteCatalogEducation(id) {
      this.$store
          .dispatch(DELETE_ITEM_BY_ID, {
            url: this.restUrl + "/" + id,
          })
          .then(() => {
            if (!this.error) {
              this.successMessage = this.$t("general.successfully_deleted");
              this.applyFilter();
            } else {
              this.errorMessages.push(this.error)
            }
          });
    },
    handleOnDeleteCard(id, has_been_assigned) {
      let self = this;
      if (has_been_assigned) {
        Swal.fire({
          title: this.$t('general.confirm_delete_assigned_education'),
          icon: "question",
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes'),
          cancelButtonText: this.$t('general.give_up'),
          confirmButtonColor: "#e31748",
        }).then((result) => {
          if (result.isConfirmed) {
            self.deleteCatalogEducation(id);
          }
        });
        return false;
      }

      Swal.fire({
        title: this.$t('general.sure_to_delete'),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.give_up'),
        confirmButtonColor: "#e31748",
      }).then((result) => {
        if (result.isConfirmed) {
          self.deleteCatalogEducation(id);
        }
      });
    },
    handleOnClickCard(event, payload) {
      if (event === 'goDemoPage') {
        this.$router.push({ name: 'company.requests.training', params: { id: payload } })
      } else if (event === 'goEditPage') {
        this.$router.push({ name: 'company.education.catalog.edit', params: { id: payload } })
      }
    },
    fixDate(value) {
      return moment().seconds(value).toNow();
    },
    applyFilter(event = null) {
      if (event?.target?.checked && event?.target?._value === 0) {
        this.kinds = [0, 1, 2, 3];
      } else if (!event?.target?.checked && event?.target?._value === 0) {
        this.kinds = [];
      }
      this.$set(this.filters, 'page', this.page)
      // this.$set(this.filters, 'training_type_id', this.selected_type.id)
      if (!(this.options.length === 1 && this.options[0] === 0)) {
        this.$set(this.filters, 'training_type_id[]', this.options)
      }
      if (!(this.kinds.length === 1 && this.kinds[0] === 0)) {
        this.$set(this.filters, 'training_kind_id[]', this.kinds)
      }
      this.$set(this.filters, 'search', this.search)
      this.$set(this.filters, 'order_by', this.order_by)

      // Loading state'i aktifleştir
      this.defaultLoadingModal = true;

      this.$store.dispatch(GET_ITEMS, {
        url: this.restUrl,
        acceptPromise: false,
        filters: this.filters,
      }).then((response) => {
        this.defaultLoadingModal = false
        if (response && response.data) {
          // Yanıt başarılıysa ve data varsa cache'le
          this.cachedItems = response.data;
        }
      }).catch(error => {
        console.error("API Error:", error);
        this.defaultLoadingModal = false;
      });
    },
    changeTrainingType(item = null) {
      if (item) {
        this.selected_type = item
      } else {
        this.selected_type.id = 0
        this.selected_type.name = this.$t('education.all_categories')
      }

      this.applyFilter()
    }
  },
  watch: {
    "filter.search": function (val) {
      this.page = 1;
      this.debouncedFilterSearch();
    },
    searchQuery: _.debounce(function () {
      this.page = 1
      this.isTyping = false;
    }, 1000),
    isTyping: function (value) {
      if (!value) {
        this.searchUser(this.searchQuery);
      }
    },
    successMessage() {
      this.debouncedResetValues();
    },
    errorMessages() {
      this.debouncedResetValues();
    },
  },
  beforeDestroy() {
    const modal = UIkit.modal("#shareSettings");
    if (modal) modal.$destroy(true);
  },
  mounted() {
    this.selected_type_name = this.$t('education.all_categories')
    let self = this;
    store.dispatch(_TRAINING_KIND_MODULE + '/' + GET_TRAINING_KINDS, {
      url: TRAINING_KIND_URL
    });

    this.$store.dispatch(GET_ITEMS, {
      url: this.trainingCategoryUrl,
      acceptPromise: true,
    }).then(
        (response) => {
          if (response.status) {
            self.educationTypes = response.data;
            self.educationTypes.unshift({ id: 0, name: this.$t('education.all_categories') });
          }
        }
    );
    if (this.superAdmin()) {
      this.$store.dispatch(MODULE_COMPANY + '/' + GET_COMPANY, {
        url: COMPANY_URL,
        filters: {
          type: this.type,
          like: this.filter.search,
          page: this.page,
          per_page: 6,
          order_by: this.filter.order_by,
          sort: this.filter.sort,
        }
      })
    }

    this.initializeCachedItems()
  },
  created: function () {
    this.debouncedFilterSearch = _.debounce(this.filterResult, 500);
    this.debouncedResetValues = _.debounce(this.resetMessages, 2000);
  },
}

</script>

<style scoped>
ul.ks-cboxtags li input[type=checkbox] {
  height: 100%;
}

.disabled {
  pointer-events: none;
}

.card-cover-image {
  width: 100%;
  height: 120px;
  object-fit: cover;
  border-radius: 4px;
}

.modal-footer-custom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #e5e5e5;
}
</style>
